export const OFFLINE_OPERATIONS = {
    VICTIM: {
        CREATE: 'create_victim'
    },
    CONTACT: {
        CREATE: 'create_contact'
    }
} as const;

// Type for all operation types
export type OfflineOperationType = typeof OFFLINE_OPERATIONS[keyof typeof OFFLINE_OPERATIONS][keyof typeof OFFLINE_OPERATIONS[keyof typeof OFFLINE_OPERATIONS]];
